<div style="padding: 15px">
    <table *ngIf="data">
        <tr>
            <td style="vertical-align: top; width: 70px">
                <profile-picture
                    class="avatar"
                    [size]="50"
                    [primaryIdentifier]="data.identifier"
                    [name]="data.name"
                >
                </profile-picture>
            </td>

            <td style="vertical-align: top">
                <h2 class="g-card-title" style="font-size: 22px; margin-top: 0">{{ data.name }}</h2>
                <p class="g-text-content" *ngIf="data.type">{{ data.type }}</p>
                <p *ngIf="data.email">
                    <a href="{{ formatEmailTo() }}">{{ data.email }}</a>
                </p>
                <p class="g-text-content" *ngIf="data.phone">c: {{ formatPhone(data.phone) }}</p>
            </td>
        </tr>
    </table>
</div>
